import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MyAccountViewModel } from '@aiii/nn-types/view-models/account';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(private http: HttpClient) {}

  /**
   * 取得帳戶持有者本人可查詢到的帳戶資料
   */
  public async getMyAccount(): Promise<MyAccountViewModel> {
    return await lastValueFrom(this.http.get<MyAccountViewModel>(environment.api.account.getMyAccount));
  }

  /**
   * 連結帳戶的 LINE User ID 跟手機號碼
   * @description 因為只透過 OA 註冊帳戶的人其資料只會有 LINE User ID，而只透過 APP 手機註冊帳戶的人其資料只會有手機號碼。當用 LINE 登入的人要註冊角色時需要填寫手機號碼，此時要連結這兩筆帳戶資料
   */
  public async linkAccount(phoneToken: string): Promise<void> {
    const token: string = await lastValueFrom(
      this.http.patch(environment.api.account.linkAccount, { phoneToken }, { responseType: 'text' })
    );

    // 更新儲存在瀏覽器上的 Token
    localStorage.setItem('token', token);
  }

  /**
   * 檢查目前 LINE 帳戶是否可綁定指定手機。
   */
  public async checkPhoneLinkAvailability(phone: string): Promise<void> {
    await lastValueFrom(this.http.post(environment.api.account.checkPhoneLinkAvailability, { phone }));
  }

  /**
   * 同意使用者條款
   */
  public async setAgreeTerms(): Promise<void> {
    await lastValueFrom(this.http.post<null>(environment.api.account.setAgreeTerms, {}));
  }

  /**
   * 更新 App 裝置的 FCM Registration Token。
   */
  public async setFcmToken(fcmToken: string): Promise<void> {
    await lastValueFrom(this.http.patch(environment.api.account.setFcmToken, { fcmToken }, { responseType: 'text' }));
  }
}
